import { render, staticRenderFns } from "./Now.vue?vue&type=template&id=e88a5332"
import script from "./Now.vue?vue&type=script&lang=js"
export * from "./Now.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports